import { sentenceCase } from 'change-case';
import { Stack, StackDetail } from '../types/Stack';

export enum STACK_MAP_OPERATION {
    DETAILED = 'DETAILED',
}

const StackMapper: { [key: string]: any } = {
    [STACK_MAP_OPERATION.DETAILED]: (stack: Stack): StackDetail => ({
        id: stack.id,
        status: sentenceCase(stack.status),
        apiJobId: stack.apiJobId,
        createdAt: stack.createdAt && new Date(stack.createdAt).toLocaleString(),
        updatedAt: stack.updatedAt && new Date(stack.updatedAt).toLocaleString(),
        client: stack.client,
        jobs: stack.jobs.map((job) => ({
            id: job.id,
            status: sentenceCase(job.status),
            apiJobId: job.apiJobId,
            pickupAt: job.pickupAt && new Date(job.pickupAt).toLocaleString(),
            dropoffAt: job.dropoffAt && new Date(job.dropoffAt).toLocaleString(),
            assignmentCode: job.assignmentCode,
            transportType: job.transportType,
            fleets: job.fleets,
            createdAt: job.createdAt && new Date(job.createdAt).toLocaleString(),
            updatedAt: job.updatedAt && new Date(job.updatedAt).toLocaleString(),
            clientId: job.clientId,
            stackId: job.stackId,
        })),
        pickups: stack.jobs.map((job) => job.deliveries.map((delivery) => delivery.pickup)).flat(),
        dropoffs: stack.jobs.map((job) => job.deliveries.map((delivery) => delivery.dropoff)).flat(),
    }),
};

export default StackMapper;
